import type { ArticleListItem } from "@/fixtures/ej-health/medical-news-fixtures";
import type { Author, SidebarItem } from "@/fixtures/ej-health/fixtures";
import {
  DOCTORS_VIDEOS,
  EXERCISE_VIDEOS,
} from "@/fixtures/ej-health/fixtures";
import { DOCTORS_LOUNGE_VIDEOS } from "@/fixtures/ej-health/doctors-lounge/fixtures";

const CATEGORY = "醫健新知";

export const CATEGORY_ARTICLES: ArticleListItem[] = [
  {
    category: CATEGORY,
    title: "【木瓜】一文看清營養價值、好處、卡路里、食譜及食用禁忌",
    excerpt:
      "木瓜（Papaya）是熱帶地區最常見的水果之一，在香港街市和超市全年都能輕鬆買到。木瓜卡路里高唔高？木瓜真的能豐胸嗎？生...",
    time: "30分鐘前",
    img: "/images/ej-health/hero-papaya-v2.png",
  },
  {
    category: CATEGORY,
    title: "【五指毛桃】一文看清營養價值、好處、禁忌及食譜",
    excerpt:
      "五指毛桃是嶺南地區家喻戶曉的藥食兩用植物，其根部富含多種營養素與活性成分，素有「南芪」之稱。本文將深入解析五指毛桃的營養...",
    time: "1小時前",
    img: "/images/ej-health/article-fivefingerherb.png",
  },
  {
    category: CATEGORY,
    title: "【大蒜】一文看清營養價值、食用好處、卡路里、食譜及禁忌",
    excerpt:
      "大蒜除了調味還有甚麼功效？大蒜營養價值極高，富含大蒜素，有助殺菌、降血壓及抗氧化。本文詳解大蒜的卡路里與營養成分，剖析生...",
    time: "2小時前",
    img: "/images/ej-health/thumb-garlic.png",
  },
  {
    category: CATEGORY,
    title: "【西蘭花】一文看清營養價值、好處、卡路里及3款簡易食譜",
    excerpt:
      "西蘭花有甚麼好處？作為公認的超級食物，它富含維他命C及抗氧化物。本文由營養師拆解西蘭花卡路里、6大營養價值、破解「變黃還...",
    time: "3小時前",
    img: "/images/ej-health/thumb-broccoli.png",
  },
  {
    category: CATEGORY,
    title: "【三文魚】一文看清營養價值、好處、卡路里禁忌及食譜",
    excerpt:
      "三文魚（Salmon）被譽為「水中珍品」，是不少香港人最愛的魚類之一，無論是刺身、香煎還是煙燻都各有風味。想知道三文魚卡...",
    time: "5小時前",
    img: "/images/ej-health/thumb-salmon.png",
  },
  {
    category: CATEGORY,
    title: "【士多啤梨】一文看清營養價值、卡路里、好處、清洗方法禁忌及食譜",
    excerpt:
      "想知道士多啤梨營養價值有幾高？這種水果不僅低卡路里，更富含維他命C和抗氧化物。本文為你詳細拆解食用士多啤梨的7大好處、清...",
    time: "8小時前",
    img: "/images/ej-health/thumb-strawberry.png",
  },
  {
    category: CATEGORY,
    title: "【冬瓜】一文看清營養價值、好處、卡路里及3款簡易食譜",
    excerpt:
      "想知道冬瓜營養價值有多高？冬瓜不只低卡去水腫，更能美白養顏。本文由註冊營養師審核，詳列冬瓜卡路里、5大食用好處及禁忌，即...",
    time: "12小時前",
    img: "/images/ej-health/thumb-winter-melon.png",
  },
  {
    category: CATEGORY,
    title: "【咖啡】一文看清營養價值、好處、卡路里禁忌及食譜",
    excerpt:
      "食物金字塔竟然被推翻了！我們從小所了解到的食物金字塔，穀物類是主食，然後多菜少肉，才可以建立一個健康的飲食習慣。而最近美...",
    time: "12小時前",
    img: "/images/ej-health/thumb-garlic.png",
  },
  {
    category: CATEGORY,
    title: "【五指毛桃】一文看清營養價值、好處、禁忌及食譜",
    excerpt:
      "五指毛桃是嶺南地區家喻戶曉的藥食兩用植物，其根部富含多種營養素與活性成分，素有「南芪」之稱。本文將深入解析五指毛桃的營養...",
    time: "1小時前",
    img: "/images/ej-health/article-fivefingerherb.png",
  },
  {
    category: CATEGORY,
    title: "【大蒜】一文看清營養價值、食用好處、卡路里、食譜及禁忌",
    excerpt:
      "大蒜除了調味還有甚麼功效？大蒜營養價值極高，富含大蒜素，有助殺菌、降血壓及抗氧化。本文詳解大蒜的卡路里與營養成分，剖析生...",
    time: "2小時前",
    img: "/images/ej-health/thumb-garlic.png",
  },
  {
    category: CATEGORY,
    title: "【三文魚】一文看清營養價值、好處、卡路里禁忌及食譜",
    excerpt:
      "三文魚（Salmon）被譽為「水中珍品」，是不少香港人最愛的魚類之一，無論是刺身、香煎還是煙燻都各有風味。想知道三文魚卡...",
    time: "5小時前",
    img: "/images/ej-health/thumb-salmon.png",
  },
  {
    category: CATEGORY,
    title: "【士多啤梨】一文看清營養價值、卡路里、好處、清洗方法禁忌及食譜",
    excerpt:
      "想知道士多啤梨營養價值有幾高？這種水果不僅低卡路里，更富含維他命C和抗氧化物。本文為你詳細拆解食用士多啤梨的7大好處、清...",
    time: "8小時前",
    img: "/images/ej-health/thumb-strawberry.png",
  },
];

const DOCTOR_AVATAR = "/images/ej-health/avatar-chen-junping-22.png";

/* ── Bylined articles ─────────────────────────────────────
   醫生專欄, 醫健一分鐘, 醫學通識, 食出健康, 運動懶人包 and 健康財富 are
   author-led categories: every article shows the doctor's avatar and name. The
   demo carries one article set, so the byline is attached here by rotating the
   site's own doctors rather than inventing a second set of articles — the names
   and avatars are the ones already used across the home page and sidebars. */
const BYLINE_AUTHORS: Author[] = [
  { name: "梁浩榮中醫師", avatar: "/images/ej-health/avatar-doctor-1.png" },
  { name: "王建芳醫生", avatar: "/images/ej-health/avatar-doctor-2.png" },
  { name: "袁康就博士", avatar: "/images/ej-health/avatar-doctor-3.png" },
  { name: "陳俊平醫生", avatar: "/images/ej-health/avatar-doctor-4.png" },
  { name: "葉佩珮醫生", avatar: "/images/ej-health/avatar-doctor-5.png" },
];

function withAuthors(items: ArticleListItem[], heading: string) {
  return items.map((item, i) => ({
    ...item,
    category: heading,
    author: BYLINE_AUTHORS[i % BYLINE_AUTHORS.length],
  }));
}

/* ── Video categories ─────────────────────────────────────
   動出健康 is a video category like 醫生會客室: every article under it IS a
   video, so the listing renders video cards. The fixtures are the site's own
   exercise and doctor videos, repeated to fill a listing grid. */
function asListingVideos(
  videos: { title: string; time: string; duration: string; img: string; subscriberOnly?: boolean }[],
  heading: string,
): ArticleListItem[] {
  return videos.map((v) => ({
    category: heading,
    title: v.title,
    excerpt: "",
    time: v.time,
    img: v.img,
    duration: v.duration,
    subscriberOnly: v.subscriberOnly,
  }));
}

/** 醫生會客室's own videos, bulked with the adjacent fixtures so the grid reads
 *  as a populated listing rather than a single row. */
export const DOCTORS_LOUNGE_LISTING = asListingVideos(
  [
    ...DOCTORS_LOUNGE_VIDEOS,
    ...DOCTORS_VIDEOS,
    ...EXERCISE_VIDEOS,
    ...DOCTORS_LOUNGE_VIDEOS.slice(0, 3),
  ],
  "醫生會客室",
);


/* 動出健康's own library.

   The category ran on three exercise clips repeated to fill the grid, so the
   listing showed the same 伸展解決五常痛 three times over. QA: "add 12 more
   video article items". These are twelve distinct sessions drawn from the
   site's own video stills. */
const EXERCISE_EXTRA = [
  {
    title: "肩頸放鬆４式｜久坐辦公室必學",
    time: "5小時前",
    duration: "06:12",
    img: "/images/ej-health/video-work-stress.png",
  },
  {
    title: "下背痛自救｜每天五分鐘核心訓練",
    time: "8小時前",
    duration: "07:45",
    img: "/images/ej-health/video-stretch-7.png",
  },
  {
    title: "膝關節保養操｜上落樓梯唔再痛",
    time: "1天前",
    duration: "09:03",
    img: "/images/ej-health/figma/columns-thumb-knee.png",
  },
  {
    title: "初學者帶氧入門｜由行到跑的四星期計劃",
    time: "1天前",
    duration: "11:20",
    img: "/images/ej-health/figma/hero-sidebar-stairs.png",
    subscriberOnly: true,
  },
  {
    title: "辦公室伸展｜一張椅完成全身放鬆",
    time: "2天前",
    duration: "05:38",
    img: "/images/ej-health/video-coworker-emotion.png",
  },
  {
    title: "長者平衡力訓練｜預防跌倒六式",
    time: "2天前",
    duration: "08:57",
    img: "/images/ej-health/video-elderly-symptoms.png",
  },
  {
    title: "睡前放鬆瑜伽｜幫助入睡的呼吸法",
    time: "3天前",
    duration: "10:14",
    img: "/images/ej-health/video-mood-disorder.png",
  },
  {
    title: "手腕與前臂伸展｜長時間打字必做",
    time: "3天前",
    duration: "04:52",
    img: "/images/ej-health/video-stretch-6.png",
  },
  {
    title: "居家肌力訓練｜無器材下肢強化",
    time: "4天前",
    duration: "12:06",
    img: "/images/ej-health/video-youth-symptoms.png",
    subscriberOnly: true,
  },
  {
    title: "產後核心修復｜由腹式呼吸開始",
    time: "5天前",
    duration: "09:41",
    img: "/images/ej-health/video-children-support.png",
  },
  {
    title: "跑步後收操｜減低乳酸堆積",
    time: "6天前",
    duration: "06:29",
    img: "/images/ej-health/video-stretch-5.png",
  },
  {
    title: "糖尿病友運動指南｜安全控糖的強度",
    time: "1週前",
    duration: "13:18",
    img: "/images/ej-health/figma/featured-hero-diabetes.png",
  },
];

const EXERCISE_LISTING = asListingVideos(
  [...EXERCISE_VIDEOS, ...EXERCISE_EXTRA, ...DOCTORS_VIDEOS],
  "動出健康",
);


export const CATEGORY_POPULAR_LIST: SidebarItem[] = [
  {
    time: "15分鐘前",
    title: "脖子淋巴腫大疑雲（上）",
    img: "/images/ej-health/thumb-neck-lymph-author.png",
    author: { name: "王建芳醫生", avatar: DOCTOR_AVATAR },
  },
  {
    time: "28分鐘前",
    title: "浮針源自傳統直針刺",
    img: "/images/ej-health/thumb-fuzhen-acupuncture.png",
    author: { name: "袁康就博士", avatar: DOCTOR_AVATAR },
  },
  {
    time: "45分鐘前",
    title: "【大蒜】一文看清營養價值、食用好處、卡路里、食譜及禁忌",
    img: "/images/ej-health/thumb-garlic.png",
  },
  {
    time: "58分鐘前",
    title: "資助18至49歲長期病患 預防併發症 速打流感針",
    img: "/images/ej-health/hero-flu-vaccine.png",
    author: { name: "陳俊平醫生", avatar: DOCTOR_AVATAR },
  },
  {
    time: "28分鐘前",
    title: "消委會去頭皮洗頭水｜4款洗頭水樣本含有歐盟禁用成份「吡硫鎓鋅」",
    img: "/images/ej-health/thumb-shampoo.png",
  },
  // Sixth row: 最新文章 renders six.
  {
    time: "1小時前",
    title: "流感高峰期未過 醫生教你分辨感冒與流感徵狀",
    img: "/images/ej-health/thumb-flu-vaccine.png",
    author: { name: "王建芳醫生", avatar: DOCTOR_AVATAR },
  },
];

/* ────────────────────────────────────────────────────────
   Category registry — one listing template, many slugs.

   The route is FLAT: `/ej-health/<slug>`, which is the shape 醫健新知
   (`/ej-health/medical-news`) and 醫生會客室 (`/ej-health/doctors-lounge`)
   already had. The old `/ej-health/topic/<slug>` nesting is gone — a category
   is a section of the site, not a sub-collection of a "topic" page, and there
   was no `/ej-health/topic` worth landing on.

   營養學 is NOT here. It is a tag (`/ej-health/tag/營養學`), and the tag route
   serves it; the nine below are the site's categories.
   ──────────────────────────────────────────────────────── */
export type CategoryConfig = {
  slug: string;
  heading: string;
  eyebrow?: string;
  description: string;
  items: ArticleListItem[];
  popularList: SidebarItem[];
  relatedTags?: string[];
  /** Video categories render video cards, not article cards. */
  variant?: "articles" | "videos";
};

/**
 * The categories share the demo article set; what differs is the editorial
 * framing and HOW the articles present.
 *
 * `byline` attaches a doctor to every article (the six author-led categories);
 * `variant: "videos"` swaps the article grid for a video grid and takes the
 * video fixtures instead. Everything else is one template.
 */
function makeCategory(
  slug: string,
  heading: string,
  description: string,
  relatedTags?: string[],
  opts: { byline?: boolean; variant?: "articles" | "videos" } = {},
): CategoryConfig {
  const items =
    opts.variant === "videos"
      ? EXERCISE_LISTING
      : opts.byline
        ? withAuthors(CATEGORY_ARTICLES, heading)
        : CATEGORY_ARTICLES;
  return {
    slug,
    heading,
    eyebrow: "分類",
    description,
    items,
    popularList: CATEGORY_POPULAR_LIST,
    relatedTags,
    variant: opts.variant,
  };
}

export const CATEGORIES: Record<string, CategoryConfig> = {
  "medical-knowledge": makeCategory(
    "medical-knowledge",
    "醫學通識",
    "拆解最新醫學研究與常見疾病知識，由專科醫生為你逐一講解。",
    ["疾病預防", "癌症篩查", "慢性疾病", "醫療科技", "公共衞生"],
    { byline: true },
  ),
  featured: makeCategory(
    "featured",
    "健康精選",
    "編輯精選本周最值得一讀的健康話題與生活實用資訊。",
    ["消委會", "食物安全", "都市健康", "生活實用", "熱門話題"],
  ),
  "eat-well": makeCategory(
    "eat-well",
    "食出健康",
    "由食材營養到簡易食譜，教你食得開心又食得健康。",
    ["健康食譜", "食材營養", "低卡飲食", "在家煮食", "輕食"],
    { byline: true },
  ),
  "med-tech": makeCategory(
    "med-tech",
    "醫 Tech",
    "人工智能、生物科技與數碼醫療，前沿醫療科技一次看清。",
    ["人工智能", "生物科技", "數碼醫療", "穿戴裝置", "遠程醫療"],
  ),
  exercise: makeCategory(
    "exercise",
    "動出健康",
    "從伸展、帶氧到肌力訓練，動起來改善身心健康。",
    ["伸展運動", "帶氧運動", "肌力訓練", "復康運動", "運動傷害"],
    { variant: "videos" },
  ),
  "health-wealth": makeCategory(
    "health-wealth",
    "健康財富",
    "醫療保險、健康管理與退休規劃，守護你的健康與荷包。",
    ["醫療保險", "健康管理", "退休規劃", "自願醫保", "理財"],
    { byline: true },
  ),
  "workout-guide": makeCategory(
    "workout-guide",
    "運動懶人包",
    "整合最實用的運動指南與圖解，讓你輕鬆上手。",
    ["運動指南", "在家運動", "圖解", "新手入門", "懶人運動"],
    { byline: true },
  ),
  // 醫生專欄 and 醫健一分鐘 were nav items pointing at OTHER pages — 醫生專欄
  // opened 醫生會客室 and 醫健一分鐘 opened a video detail page — because
  // neither had a listing of its own. Both are author-led categories.
  "doctor-columns": makeCategory(
    "doctor-columns",
    "醫生專欄",
    "西醫、中醫與專職醫療人員的第一身筆記，從診症室看健康。",
    ["醫生專欄", "臨床筆記", "中醫", "專科", "醫患溝通"],
    { byline: true },
  ),
  "one-minute": makeCategory(
    "one-minute",
    "醫健一分鐘",
    "一分鐘一個健康知識點，由醫生用最短篇幅講清楚。",
    ["醫健一分鐘", "健康小知識", "圖解", "短片", "日常保健"],
    { byline: true },
  ),
};

export function getCategory(slug: string): CategoryConfig | undefined {
  return CATEGORIES[slug];
}

export const CATEGORY_SLUGS = Object.keys(CATEGORIES);

/**
 * The slug of the CATEGORY a tag belongs to, or `undefined` when none does.
 *
 * Tag clouds are written as Chinese labels (「醫學通識」) while category routes
 * are English slugs (`medical-knowledge`), so a pill cannot link to itself.
 * Match on the category's own heading first, then on the tags it declares.
 *
 * `undefined` is the common case and not a failure: a pill that names no
 * category goes to its TAG page instead, which resolves for any tag.
 */
export function categorySlugForTag(tag: string): string | undefined {
  const categories = Object.values(CATEGORIES);
  return (
    categories.find((c) => c.heading === tag)?.slug ??
    categories.find((c) => c.relatedTags?.includes(tag))?.slug
  );
}
